import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '../../providers/firebase.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../../models/client';

@Component({
  selector: 'app-component-themes',
  templateUrl: './component-themes.component.html',
  styleUrls: ['./component-themes.component.css']
})
export class ComponentThemesComponent implements OnInit {
  key: string;
  clientData: Client;
  themes: any;
  selectedTheme: any;

  constructor(
    public afService: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.afService.getThemes().subscribe((themes) => {
      this.themes = themes;
    })
    this.route.params.subscribe(params => {
      this.key = params["key"];
      this.afService.getClientInfo(this.key).subscribe(clientData => {
        this.clientData = clientData;
        console.log(this.clientData);
      });
    });
  }

  setTheme(theme) {
    this.selectedTheme = theme;
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/component-themes/component-themes.component.ts